

































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import CpoPemberianModal from "@/components/modal/CpoPemberianModal.vue";
import { storeOrderEmergensi } from "@/store/modules/OrderEmergensiStore";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import {
  CpoEmergensiItem,
  CpoEmergensiOrder,
  CpoEmergensiPemberian
} from "@/types/order_emergensi";
import { STATUS_ORDER_EMERGENSI } from "@/components/pemeriksaan/resep-obat/order-emergensi/orderEmergensi.config";

@Component({
  components: { CpoPemberianModal },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CpoEmergensiPanel extends Vue {
  @Prop({ required: true }) register!: string;
  @Prop() rm!: string;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;

  isReadOnly!: () => boolean;

  modalPemberian = false;
  verifikator: number | null = null;
  panelTerbuka: number[] = [0];
  dataPemberian: Record<string, any> = {
    id: null,
    cpo_item_id: null,
    nama_obat: "",
    ham_lasa: null,
    dr_id: null,
    kd_obat: "",
    unit_id: null,
    dosis: "",
    rute: "",
    jadwal: "",
    tgl: "",
    time: null,
    verified_at: null
  };

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get orders(): CpoEmergensiOrder[] {
    return storeOrderEmergensi.registerId === String(this.register) ? storeOrderEmergensi.cpoList : [];
  }

  get loading(): boolean {
    return storeOrderEmergensi.loadingCpo;
  }

  mounted() {
    this.muat();
  }

  @Watch("register")
  onRegisterChange() {
    this.muat();
  }

  muat() {
    if (!this.register) return;
    storeOrderEmergensi.muatCpo(this.register);
  }

  statusInfo(order: CpoEmergensiOrder) {
    return STATUS_ORDER_EMERGENSI[order.status] || { label: order.status, color: "grey" };
  }

  formatWaktu(nilai: string | null): string {
    return nilai ? moment(nilai, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm") : "-";
  }

  formatTanggal(nilai: string | null): string {
    return nilai ? moment(nilai, "YYYY-MM-DD").format("DD/MM") : "";
  }

  rowClass(item: CpoEmergensiItem): string {
    if (item.ham_lasa == "1") return "red-row";
    if (item.ham_lasa == "2") return "yellow-row";
    return "";
  }

  isiData(order: CpoEmergensiOrder, item: CpoEmergensiItem, pemberian: CpoEmergensiPemberian | null) {
    this.dataPemberian = {
      id: pemberian ? pemberian.id : null,
      cpo_item_id: item.cpo_item_id,
      nama_obat: item.nama_obat,
      ham_lasa: item.ham_lasa,
      dr_id: item.dr_id,
      kd_obat: "EMG-" + item.cpo_item_id,
      unit_id: pemberian ? pemberian.unit_id : order.unit_id,
      dosis: pemberian ? pemberian.dosis_text : item.dosis,
      rute: item.rute,
      jadwal: item.jadwal,
      tgl: pemberian ? pemberian.date : moment().format("YYYY-MM-DD"),
      time: pemberian ? pemberian.time : null,
      verified_at: pemberian ? pemberian.verified_at : null
    };
    this.verifikator = pemberian && pemberian.verifikator ? pemberian.verifikator.id : null;
    this.modalPemberian = true;
  }

  tambahPemberian(order: CpoEmergensiOrder, item: CpoEmergensiItem) {
    if (this.readOnly || this.disabled) return;
    this.isiData(order, item, null);
  }

  ubahPemberian(order: CpoEmergensiOrder, item: CpoEmergensiItem, pemberian: CpoEmergensiPemberian) {
    if (!pemberian.pemberi || Number(pemberian.pemberi.id) !== Number(userModule.user.id)) {
      appModule.sendErrorAlert(
        "Catatan pemberian hanya dapat diubah oleh pemberinya (" + (pemberian.pemberi ? pemberian.pemberi.nama : "-") + ")."
      );
      return;
    }
    this.isiData(order, item, pemberian);
  }
}
